import { render, staticRenderFns } from "./VoiceConfigModal.vue?vue&type=template&id=37d00004&scoped=true"
import script from "./VoiceConfigModal.vue?vue&type=script&lang=js"
export * from "./VoiceConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d00004",
  null
  
)

export default component.exports